export default "__VITE_ASSET__DgjG0JsN__"